import { createContext } from 'react'

const StateContext = createContext({ isLoggedIn: false })

export default StateContext
